import {trackBeginCheckout} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

export const useTrackBeginCheckout = () => {
  const {TrackingClient} = useTracking();

  return ({
    customerType,
    entryTimestamp,
    label,
  }: {
    customerType: 'existing' | 'new' | 'guest';
    entryTimestamp: number;
    label: 'internal_checkout' | 'klarna_express_checkout';
  }) => {
    TrackingClient.track(
      trackBeginCheckout({customerType, entryTimestamp, label}),
    );
  };
};
